import { useEffect } from "react"

const useTitle = title => {
  useEffect(()=>{
    document.title = `${title} - SaaD Dentistry`;
  },[title])
}

export default useTitle;